import {useEffect, useState} from 'react';
import {ButtonCopyToClipboard} from '../ButtonCopyToClipboard';
import './ConvertData.css';
import {RadioFormat} from './RadioFormat';
const yaml = require('js-yaml');
const jxon = require('jxon');

export const ConvertData = () => {
	const [sourceContent, setSourceContent] = useState<string>(
		'<hello>world</hello>'
	);
	const [destinationContent, setDestinationContent] = useState<string>('');
	const [sourceFormat, setSourceFormat] = useState<string>('XML');
	const [destinationFormat, setDestinationFormat] = useState<string>('JSON');

	const xmlToJson = () => {
		return () => {
			try {
				const result = jxon.stringToJs(sourceContent);
				setDestinationContent(JSON.stringify(result));
			} catch (e) {
				console.log(e);
				setDestinationContent((e as SyntaxError).message);
			}
		};
	};
	const xmlToYaml = () => {
		try {
			const jsonobj = jxon.stringToJs(sourceContent);
			const doc = yaml.dump(jsonobj, {
				styles: {
					'!!null': 'canonical', // dump null as ~
				},
				sortKeys: true, // sort object keys
			});
			setDestinationContent(doc);
		} catch (e) {
			console.log(e);
			setDestinationContent((e as SyntaxError).message);
		}
	};
	const jsonToXml = () => {
		try {
			const jsonobj = JSON.parse(sourceContent);
			const result = jxon.stringify(jsonobj);
			setDestinationContent(result);
		} catch (e) {
			console.log(e);
			setDestinationContent((e as SyntaxError).message);
		}
	};
	const yamlToXml = () => {
		try {
			const doc = yaml.load(sourceContent);
			const result = jxon.stringify(doc);
			setDestinationContent(result);
		} catch (e) {
			console.log(e);
			setDestinationContent((e as SyntaxError).message);
		}
	};

	const yamlToJson = () => {
		try {
			const doc = yaml.load(sourceContent);
			setDestinationContent(JSON.stringify(doc));
		} catch (e) {
			console.log(e);
			setDestinationContent((e as SyntaxError).message);
		}
	};
	const validateJson = () => {
		if (sourceContent.indexOf("'") >= 0) {
			setDestinationContent(
				'Only use double quotes in your json source please!!!'
			);
			return false;
		}
		return true;
	};
	const jsonToYaml = () => {
		try {
			const jsonContent = sourceContent;
			const jsonobj = JSON.parse(jsonContent);
			const doc = yaml.dump(jsonobj, {
				styles: {
					'!!null': 'canonical', // dump null as ~
				},
				sortKeys: true, // sort object keys
			});
			setDestinationContent(doc);
		} catch (e) {
			console.log(e);
			setDestinationContent((e as SyntaxError).message);
		}
	};
	useEffect(() => {
		const doConvert = () => {
			try {
				console.log(`From ${sourceFormat} to ${destinationFormat} `);
				if (sourceFormat === destinationFormat) {
					setDestinationContent(sourceContent);
				} else if (sourceFormat === 'YAML') {
					if (destinationFormat === 'JSON') {
						yamlToJson();
					} else if (destinationFormat === 'XML') {
						yamlToXml();
					}
				} else if (sourceFormat === 'XML') {
					if (destinationFormat === 'JSON') {
						xmlToJson()();
					} else if (destinationFormat === 'YAML') {
						xmlToYaml();
					}
				} else if (sourceFormat === 'JSON') {
					if (validateJson() === false) return;
					if (destinationFormat === 'YAML') {
						jsonToYaml();
					} else if (destinationFormat === 'XML') {
						jsonToXml();
					}
				}
			} catch (error) {
				setDestinationContent(JSON.stringify(error));
			}
		};
		doConvert();
	}, [
		sourceContent,
		sourceFormat,
		destinationFormat,
		jsonToXml,
		jsonToYaml,
		validateJson,
		xmlToYaml,
		yamlToJson,
		yamlToXml,
	]);
	return (
		<div className='panel'>
			<div className='select-formats'>
				<RadioFormat
					key='source-format'
					title='Source format'
					setValue={setSourceFormat}
					name='sourceFormat'
					value={sourceFormat}
				/>
				<RadioFormat
					value={destinationFormat}
					key='destination-format'
					title='Destination format'
					setValue={setDestinationFormat}
					name='destinationFormat'
				/>
			</div>
			<div className='convert-area'>
				<div className='convert-area-header'>
					{sourceFormat} to {destinationFormat}
				</div>
				<div className='convert-area-textarea source'>
					<textarea
						value={sourceContent}
						onChange={(e) => {
							setSourceContent(e.target.value);
						}}
						placeholder={'Source text'}
					/>
				</div>
				<div className='convert-area-textarea destination'>
					<textarea
						value={destinationContent}
						readOnly
						placeholder={'Destination text'}
					/>
				</div>
				<div className='button-copy'>
					<ButtonCopyToClipboard
						text={destinationContent}
						key={'copy_format'}
					/>
				</div>
			</div>
		</div>
	);
};
